<div class="user-history-container">
  <div class="history-content">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'pages.user-update.history.loading' | translate }}</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <mat-icon color="warn">error_outline</mat-icon>
      <p>{{ 'pages.user-update.history.error' | translate }}</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && !error && userActivity.length === 0" class="empty-state">
      <mat-icon color="warn">error_outline</mat-icon>
      <p>{{ 'pages.user-update.history.empty' | translate }}</p>
    </div>

    <!-- History Table -->
    <div *ngIf="!loading && !error && userActivity.length > 0" class="table-container">
      <p class="history-legend">{{ 'pages.user-update.historyLegend.legend' | translate }} : <span class="history-legend-admin">{{ 'pages.user-update.historyLegend.admin' | translate }}</span> - <span  class="history-legend-user">{{ 'pages.user-update.historyLegend.user' | translate }}</span> - <span class="history-legend-other-user">{{ 'pages.user-update.historyLegend.otherUser' | translate }}</span></p>
      <table mat-table [dataSource]="userActivity" class="history-table">
        
        <!-- Time Column -->
        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef>{{ 'pages.user-update.history.tableHeaders.time' | translate }}</th>
          <td mat-cell *matCellDef="let activity">{{ formatTime(activity.created_at) }}</td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>{{ 'pages.user-update.history.tableHeaders.date' | translate }}</th>
          <td mat-cell *matCellDef="let activity">{{ formatDate(activity.created_at) }}</td>
        </ng-container>

        <!-- Activity Column -->
        <ng-container matColumnDef="activity">
          <th mat-header-cell *matHeaderCellDef>{{ 'pages.user-update.history.tableHeaders.activity' | translate }}</th>
          <td mat-cell *matCellDef="let activity"
              [innerHTML]="getActivityDescription(activity) | safeHtml">
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['time', 'date', 'activity']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['time', 'date', 'activity'];"></tr>
      </table>
    </div>
  </div>
</div> 